import { render, staticRenderFns } from "./LmFormSubtitlesBuilderUi.vue?vue&type=template&id=1a707f7b"
import script from "./LmFormSubtitlesBuilderUi.vue?vue&type=script&lang=js"
export * from "./LmFormSubtitlesBuilderUi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports